import { getTypographyFontSizeStyles } from "../../theme/selectors";
import { sizes } from "../../enums/sizeEnum";
import { getStyleValueByTypeof } from "../../helpers/helpers";
export var defaultPaddings = {
  small: '0 12px',
  normal: '0 16px',
  large: '0 24px'
};
export var defaultBorderRadiuses = {
  small: '3px',
  normal: '4px',
  large: 4
};
export var defaultHeights = {
  small: 30,
  normal: 40,
  large: 50
};
export var getButtonSize = function getButtonSize(_ref) {
  var _ref2, _ref3, _ref4;

  var size = _ref.size,
      theme = _ref.theme,
      icon = _ref.icon,
      circle = _ref.circle;
  var buttonTheme = theme === null || theme === void 0 ? void 0 : theme.button;
  var buttonThemeHeight = (_ref2 = buttonTheme === null || buttonTheme === void 0 ? void 0 : buttonTheme.height) !== null && _ref2 !== void 0 ? _ref2 : defaultHeights;
  var buttonThemeBorderRadius = (_ref3 = buttonTheme === null || buttonTheme === void 0 ? void 0 : buttonTheme.borderRadius) !== null && _ref3 !== void 0 ? _ref3 : defaultBorderRadiuses;
  var buttonThemePadding = (_ref4 = buttonTheme === null || buttonTheme === void 0 ? void 0 : buttonTheme.padding) !== null && _ref4 !== void 0 ? _ref4 : defaultPaddings;

  if (size === sizes.small) {
    var _height = buttonThemeHeight.small;

    var _borderRadius = getStyleValueByTypeof(buttonThemeBorderRadius.small);

    return "\n      height: ".concat(_height, "px;\n      padding: ").concat(buttonThemePadding.small, ";\n      border-radius: ").concat(circle ? "".concat(_height, "px") : _borderRadius, ";\n\n      ").concat(getTypographyFontSizeStyles(theme, 200), "\n      ").concat(icon ? "width: ".concat(_height, "px; padding: 0;") : '', "\n    ");
  }

  if (size === sizes.normal) {
    var _height2 = buttonThemeHeight.normal;

    var _borderRadius2 = getStyleValueByTypeof(buttonThemeBorderRadius.normal);

    return "\n      height: ".concat(_height2, "px;\n      padding: ").concat(buttonThemePadding.normal, ";\n      border-radius: ").concat(circle ? "".concat(_height2, "px") : _borderRadius2, ";\n      ").concat(getTypographyFontSizeStyles(theme, 300), "\n      ").concat(icon ? "width: ".concat(_height2, "px; padding: 0;") : '', "\n    ");
  }

  var height = buttonThemeHeight.large;
  var borderRadius = getStyleValueByTypeof(buttonThemeBorderRadius.large);
  return "\n    height: ".concat(height, "px;\n    padding: ").concat(buttonThemePadding.large, ";\n    border-radius: ").concat(circle ? "".concat(height, "px") : borderRadius, ";\n    ").concat(getTypographyFontSizeStyles(theme, 400), "\n    ").concat(icon ? "width: ".concat(height, "px; padding: 0;") : '', "\n  ");
};